import { useTranslation } from "react-i18next";

export const useMenuItems = () => {
  const { t } = useTranslation();

  return [
    {
      section: t('sidebar.main'),
      items: [
        {
          id: "dashboard",
          label: t('sidebar.dashboard'),
          icon_src: "/icons/dashboard.png",
          hasDropdown: false,
        },
        {
          id: "reports-bookings",
          label: t("sidebar.booking_report"),
          icon_src: "/icons/report.png",
          hasDropdown: false,
        },
      ],
    },
    {
      section: t("sidebar.peoples"),
      items: [
        {
          id: "customers",
          label: t("sidebar.customer"),
          icon_src: "/icons/customers.png",
          hasDropdown: false,
        },
      ],
    },
    {
      section: t("sidebar.sales") || "Sales",
      items: [
        {
          id: "bookings",
          label: t("sidebar.bookings"),
          icon_src: "/icons/bookings.png",
          hasDropdown: false,
        },
        {
          id: "bookings-calendar",
          label: t("sidebar.booking_calendar"),
          icon_src: "/icons/booking.png",
          hasDropdown: false,
        },
        {
          id: "tables",
          label: t("sidebar.tables"),
          icon_src: "/icons/table.png",
          hasDropdown: false,
        },
      ],
    },
    {
      section: t("sidebar.settings") || "Settings",
      items: [
        {
          id: "user-management",
          label: t("sidebar.users"),
          icon_src: "/icons/user.png",
          hasDropdown: false,
        },
        {
          id: "settings",
          label: t("sidebar.general_settings"),
          icon_src: "/icons/setting.png",
          hasDropdown: false,
        },
      ],
    },
  ];
};
